import Home from "../assetsV2/SideBarImage/Dashbaord.svg";
import Booking from "../assetsV2/SideBarImage/Booking.svg";
import Pos from "../assetsV2/SideBarImage/POS.svg";
import ChannelManager from "../assetsV2/SideBarImage/Channel manager.svg";
import Clients from "../assetsV2/SideBarImage/Clients.svg";
import HouseKeeping from "../assetsV2/SideBarImage/Housekeeping.svg";
import Reports from "../assetsV2/SideBarImage/Reports.svg";
import Party from "../assetsV2/SideBarImage/Party.svg";
import PaymentsSideBarIcon from "../assetsV2/SideBarImage/Payments.svg";
import Expense from "../assetsV2/SideBarImage/Expense.svg";
import Invoice from "../assetsV2/SideBarImage/Invoice.svg";
import ManageStocks from "../assetsV2/SideBarImage/stocks.svg";

import Globe from "../assets/images/svgs/dashboard-sidebar-images/globe.svg";
import ReviewsIcon from "../assetsV2/SideBarImage/Reviews.svg";
import { TranslateText } from "../utils/translation";

// Section keys — used as identifiers in DASHBOARD_NAVIGATION_OPTIONS
// and as keys in NAVIGATION_SECTIONS.
export const NAV_SECTIONS = {
  DASHBOARD:        "DASHBOARD",
  ANALYTICS:        "ANALYTICS",
  BOOKINGS:         "BOOKINGS",
  HOUSEKEEPING:     "HOUSEKEEPING",
  CLIENTS:          "CLIENTS",
  POINT_OF_SALE:    "POINT_OF_SALE",
  STOCKS:           "STOCKS",
  ACCOUNTS:         "ACCOUNTS",
  CHANNEL_MANAGER:  "CHANNEL_MANAGER",
  BOOKING_ENGINE:   "BOOKING_ENGINE",
  GUEST_EXPERIENCE: "GUEST_EXPERIENCE",
};

// Ordered list of sections with their display labels and representative icons.
// `icon` is shown in the collapsed sidebar and in the section heading.
// The order here determines the order in which sections appear in the sidebar.
export const NAVIGATION_SECTIONS = [
  { key: NAV_SECTIONS.DASHBOARD,        label: "Dashboard",        icon: Home           },
  { key: NAV_SECTIONS.BOOKINGS,         label: "Bookings",         icon: Booking        },
  { key: NAV_SECTIONS.POINT_OF_SALE,    label: "Point of Sale",    icon: Pos            },
  { key: NAV_SECTIONS.CHANNEL_MANAGER,  label: "Channel Manager",  icon: ChannelManager },
  { key: NAV_SECTIONS.BOOKING_ENGINE,   label: "Booking Engine",   icon: Globe          },
  { key: NAV_SECTIONS.ANALYTICS,        label: "Reports",          icon: Reports        },
  { key: NAV_SECTIONS.GUEST_EXPERIENCE, label: "Guest Experience", icon: ReviewsIcon    },
  { key: NAV_SECTIONS.ACCOUNTS,         label: "Accounts",         icon: Invoice        },
  { key: NAV_SECTIONS.HOUSEKEEPING,     label: "Housekeeping",     icon: HouseKeeping   },
  { key: NAV_SECTIONS.CLIENTS,          label: "Clients",          icon: Clients        },
  { key: NAV_SECTIONS.STOCKS,           label: "Stocks",           icon: ManageStocks   },
];

export const DASHBOARD_NAVIGATION_OPTIONS = [
  // ── Dashboard ─────────────────────────────────────────────────
  {
    id: "1",
    title: "Dashboard",
    img: Home,
    defaultImg: Home,
    link: "",
    jsx: "Home",
    section: NAV_SECTIONS.DASHBOARD,
    translatedTitle: <TranslateText textKey={"dashboard"} namespace="menu" />,
  },

  // ── Analytics ─────────────────────────────────────────────────
  {
    id: "11",
    title: "Reports",
    img: Reports,
    defaultImg: Reports,
    link: "reports",
    section: NAV_SECTIONS.ANALYTICS,
    translatedTitle: <TranslateText textKey={"reports"} namespace="menu" />,
  },

  // ── Front Office ──────────────────────────────────────────────
  {
    id: "2",
    title: "Bookings",
    img: Booking,
    defaultImg: Booking,
    link: "bookings",
    section: NAV_SECTIONS.BOOKINGS,
    translatedTitle: <TranslateText textKey={"bookings"} namespace="menu" />,
  },
  {
    id: "8",
    title: "Housekeeping",
    img: HouseKeeping,
    defaultImg: HouseKeeping,
    link: "house-keeping",
    section: NAV_SECTIONS.HOUSEKEEPING,
    translatedTitle: (
      <TranslateText textKey={"housekeeping"} namespace="menu" />
    ),
  },
  {
    id: "6",
    title: "Clients",
    img: Clients,
    defaultImg: Clients,
    link: "clients",
    section: NAV_SECTIONS.CLIENTS,
    translatedTitle: <TranslateText textKey={"clients"} namespace="menu" />,
  },

  // ── Point of Sale ─────────────────────────────────────────────
  {
    id: "3",
    title: "Orders",
    img: Pos,
    defaultImg: Pos,
    link: "all-orders",
    section: NAV_SECTIONS.POINT_OF_SALE,
    translatedTitle: <TranslateText textKey={"orders"} namespace="menu" />,
  },
  {
    id: "16",
    title: "Manage Stocks",
    img: ManageStocks,
    defaultImg: ManageStocks,
    link: "manageStocks",
    section: NAV_SECTIONS.STOCKS,
    translatedTitle: (
      <TranslateText textKey={"manage_stocks"} namespace="menu" />
    ),
  },

  // ── Accounts ──────────────────────────────────────────────────
  {
    id: "15",
    title: "Invoice",
    img: Invoice,
    defaultImg: Invoice,
    link: "invoice",
    section: NAV_SECTIONS.ACCOUNTS,
    translatedTitle: <TranslateText textKey={"invoice"} namespace="menu" />,
  },
  {
    id: "13",
    title: "Payments",
    img: PaymentsSideBarIcon,
    defaultImg: PaymentsSideBarIcon,
    link: "payments",
    section: NAV_SECTIONS.ACCOUNTS,
    translatedTitle: <TranslateText textKey={"payments"} namespace="menu" />,
  },
  {
    id: "12",
    title: "Ledger",
    img: Party,
    defaultImg: Party,
    link: "party",
    section: NAV_SECTIONS.ACCOUNTS,
    translatedTitle: <TranslateText textKey={"ledger"} namespace="menu" />,
  },
  {
    id: "14",
    title: "Expense",
    img: Expense,
    defaultImg: Expense,
    link: "expense",
    section: NAV_SECTIONS.ACCOUNTS,
    translatedTitle: <TranslateText textKey={"expense"} namespace="menu" />,
  },

  // ── Channel Manager ───────────────────────────────────────────
  {
    id: "5",
    title: "Channel Manager",
    img: ChannelManager,
    defaultImg: ChannelManager,
    link: "channel-manager",
    section: NAV_SECTIONS.CHANNEL_MANAGER,
    translatedTitle: (
      <TranslateText textKey={"channel_manager"} namespace="menu" />
    ),
  },
  // ── Booking Engine ────────────────────────────────────────────
  // Clicking the row opens the Booking Engine settings screen directly
  // (its own dashboard page, not the Settings drawer).
  // The separate external-link icon (rendered next to it) opens the
  // live booking engine site instead.
  {
    id: "17",
    title: "Booking Engine",
    img: Globe,
    defaultImg: Globe,
    jsx: "booking-engine",
    link: "booking-engine",
    section: NAV_SECTIONS.BOOKING_ENGINE,
    translatedTitle: (
      <TranslateText textKey={"booking_engine"} namespace="menu" />
    ),
  },
  // ── Guest Experience ──────────────────────────────────────────
  {
    id: "18",
    title: "Reputation",
    img: ReviewsIcon,
    defaultImg: ReviewsIcon,
    link: "reviews",
    section: NAV_SECTIONS.GUEST_EXPERIENCE,
    translatedTitle: (
      <TranslateText textKey={"reputation"} namespace="menu" />
    ),
  },

];

export const BillingSettingHeading = "Billing & Subscription";
